import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { SynergoCitationService } from '../../../../../service/synergo-citation/synergo-citation.service';
import { Attendance } from '../../../../../class/attendance';

@Component({
  selector: 'app-synergo-citation',
  templateUrl: './synergo-citation.component.html',
  styleUrls: ['./synergo-citation.component.scss']
})
export class SynergoCitationComponent implements OnInit {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() infoSynergoCitation: Attendance;
  public synergoCitation: Attendance;
  public msgs: Message[] = [];
  public options: any;

  constructor(
      public synergoCitationService: SynergoCitationService,
      private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }

  public cancelCitation () {
      this.close.emit(true);
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/synergo/synergo-citations/synergo-citation/synergo-citation/synergo-citation.component.ts